import { extendTheme } from '@chakra-ui/react';
import { globalStyles } from './styles';
import { breakpoints } from './foundations/breakpoints';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { linkStyles } from './components/link';
import { inputStyles } from './components/input';
import { CardComponent } from './additions/card/Card';
import { MainPanelComponent } from './additions/layout/MainPanel';
import { PanelContentComponent } from './additions/layout/PanelContent';
import { PanelContainerComponent } from './additions/layout/PanelContainer';
import { typographyFoundation } from './foundations/typography';
import { radiiFoundation } from './foundations/radii';
import { shadowsFoundation } from './foundations/shadows';
import { modalStyles } from './components/modal';
import { tabsStyles } from './components/tabs';
import { tooltipStyles } from './components/tooltip';
import { menuStyles } from './components/menu';

// Light mode default — no system color mode to keep dashboard predictable
const config = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

export default extendTheme(
  { config },
  { breakpoints },
  globalStyles,
  typographyFoundation,
  radiiFoundation,
  shadowsFoundation,
  buttonStyles,
  badgeStyles,
  linkStyles,
  inputStyles,
  modalStyles,
  tabsStyles,
  tooltipStyles,
  menuStyles,
  CardComponent,
  MainPanelComponent,
  PanelContentComponent,
  PanelContainerComponent
);
